var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Auth',[_c('br'),_c('router-link',{staticClass:"button large",attrs:{"to":"/login"}},[_vm._v("INGRESAR A OFICINA")]),_c('router-link',{staticClass:"button large",attrs:{"to":"/register"}},[_vm._v("REGISTRAR DISTRIBUIDOR")]),_c('a',{staticClass:"route",attrs:{"href":_vm.wsp,"target":"_blank"}},[_vm._v("WhatsApp de ayuda")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }